import { call, put } from "redux-saga/effects";

import { receivedAnnouncements, getAnnouncementsError } from "../actions/announcements";
import * as announcementsApi from "../api/announcements";

export function* getAnnouncements({payload}) {
  try {
    let { data } = yield call(announcementsApi.getAnnouncements, payload);

    if (data?.error) {
      yield put(getAnnouncementsError());
    } else {
      yield put(receivedAnnouncements(data));
    }
  } catch (e) {
    // TODO: throw generic error
    yield put(getAnnouncementsError());
    console.log("TODO: handle error here");
    console.log(e);
  }
}
